import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'

interface DashboardStatsParams {
  branchId?: string
  year?: number
  month?: number
}

/**
 * Fetch dashboard stats for current month by branch
 * Defaults to current month if year/month not specified
 */
export function useDashboardStats(params?: DashboardStatsParams) {
  return useQuery({
    queryKey: ['dashboard-stats', params?.branchId, params?.year, params?.month],
    queryFn: () => api.analytics.dashboard(params),
    staleTime: 60 * 1000, // 1 minute
  })
}
